
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import {
  GetUserList,
  PutUserPaw,
  PatchEditUser,
} from "@/request/common";
import MainHeader from "@/components/main-header.vue";
import NavLeft from "@/components/nav-left.vue";
import ZuzhiTree from "../../components/zuzhi-tree.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    ZuzhiTree,
  },
})
export default class Name extends mixins(listMixin) {
  private data: any = [];
  /**
   * @description 按照机构来查找
   */
  private searchInstitution(id: any) {
    this.filters["institution_id"] = id;
    this.search();
  }
  private goAdd() {
    this.$router.push({
      path: "/main/account/zhanghu-edit",
    });
  }
  private goEdit(item: any) {
    if (!item.is_active) {
      this.$message.warning("该账户已经禁用，不能编辑");
      return;
    }
    this.$router.push({
      path: "/main/account/zhanghu-edit",
      query: {
        id: item.id,
      },
    });
  }
  private resetPwd(item: any) {
    this.$confirm("确定要重置该账号的密码吗？", "重置密码", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      PutUserPaw(this, item.id, loading)
        .then((data: any) => {
          loading.close();
          this.$message.success("重置成功");
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private jinyong(item: any) {
    this.$confirm("禁用后该账户不能进入该网站，确定要禁用吗？", "禁用", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        is_active: false,
      };
      PatchEditUser(this, item.id, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("禁用成功！");
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private qiyong(item: any) {
    this.$confirm("确定要启用该账户？", "启用", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        is_active: true,
      };
      PatchEditUser(this, item.id, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("启用成功！");
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  /**
   * @description 获取列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      params: {
        search: this.filters.search,
        dept: this.filters.institution_id,
        page: this.filters.current_page,
      },
    };
    if (!this.filters.institution_id) {
      delete params.params.dept;
    }
    localStorage.setItem("accountFilter", JSON.stringify(this.filters));
    GetUserList(this, params)
      .then((res: any) => {
        loading.close();
        this.data = res.data;
        this.filters.total_count = res.total;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    if (localStorage.getItem("accountFilter")) {
      this.filters = JSON.parse(localStorage.getItem("accountFilter") as any);
    }
    this.getList();
  }
}
